import { useRouter } from 'next/router'

import { useIntl } from 'react-intl'

import { useGetBlogArticleBySlug } from 'app/services/Query/blog/blog.query'
import { generateArticleLink } from 'app/utils/helpers/blog.helpers'
import { isOfType } from 'app/utils/helpers/type.helpers'

export const useArticleView = () => {
  const { formatMessage } = useIntl()
  const { isFallback, query } = useRouter()
  const querySlug = query?.slug ?? ''
  const slug = isOfType.string(querySlug) ? querySlug : ''

  const { data: article } = useGetBlogArticleBySlug({
    slug,
    options: { enabled: false }
  })

  const {
    title = '',
    title_image_url = '',
    created_at = '',
    blog_tags = [],
    body = '',
    blog_category: blogCategory,
    title_image
  } = article ?? {}

  const breadcrumbsLinks = [
    { href: '/blog', child: formatMessage({ defaultMessage: 'Blog' }) },
    {
      href: `/blog/${blogCategory?.slug}`,
      child: blogCategory?.name
    },
    { href: '#', child: title }
  ]

  const { meta_title, meta_description: metaDescription } = article?.meta || {}
  const metaTitle = meta_title || title

  const seoDescription = formatMessage(
    { defaultMessage: '{description}' },
    { description: metaDescription || `${metaTitle} at IFnd Blog` }
  )

  const hasArticle = !isFallback && !!article?.id
  const imageAltText = title_image?.alt_text ?? title

  const shareLink = generateArticleLink({
    slug,
    categorySlug: blogCategory?.slug,
    asShareLink: true
  })

  return {
    breadcrumbsLinks,
    hasArticle,
    isPageLoading: isFallback,
    seoDescription,
    title_image_url,
    created_at,
    blog_tags,
    body,
    title,
    metaTitle,
    imageAltText,
    shareLink
  }
}
